var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 34.0233L0 3.46772L15.2778 17.3566L25 0.689941L34.7222 17.3566L50 3.46772L44.4444 34.0233H5.55556ZM44.4444 42.3566C44.4444 44.0233 43.3333 45.1344 41.6667 45.1344H8.33333C6.66667 45.1344 5.55556 44.0233 5.55556 42.3566V39.5788H44.4444V42.3566Z",
    fill: "#3b82f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile-1.758a1f2a87bb64220c31c2185a12f518.svg";
export { ForwardRef as ReactComponent };